const prefix = '[CustomerApplicationsOverview]';

export const appOverviewLoadDefaultPageSize = 5;

export class LoadApplications {
    static readonly type = `${prefix} Load Applications`;
    constructor(public readonly payload = { pageSize: appOverviewLoadDefaultPageSize }) {}
}

export class LoadMoreApplications {
    static readonly type = `${prefix} Load More Applications`;
}

export class DeleteApplication {
    static readonly type = `${prefix} Delete Application`;
    constructor(public readonly applicationId: string) {}
}

export class ResetApplicationOverviewState {
    static readonly type = `${prefix} Reset Application Overview State`;
}
